module.exports = __webpack_public_path__ + "static/fonts/NotoSansKR-Regular.7c3141b.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/NotoSansKR-Regular.woff
// module id = +Dg9
// module chunks = 1